import React, { useState } from 'react'

import useSingleton from '../../../business-components/useSingleton/useSingleton'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import {
    COLOR,
} from '../../../business-const/Color/Color'

import {
    GridContainer,
    GridItem11,
} from '../../../business-components/Grid/Grid'

//import {
//    RichTextEditorViewer
//} from '../../../business-components/RichTextEditor/RichTextEditorViewer'

import {
    RichTextEditorViewerPadrao
} from '../../../business-components/RichTextEditor/RichTextEditorViewerPadrao'

import {
    pesquisaList,
} from '../../../business-rules/List/ListService'



const GestaoPatrimonialFormVisao = ( { jsonGestaoPatrimonial } ) => {

    const [visao, setVisao] = useState('')

    useSingleton(async () => {

        if (jsonGestaoPatrimonial && jsonGestaoPatrimonial.configuracaoGestaoPatrimonial) {

            const linhaConfiguracaoGestaoPatrimonial =
                pesquisaList(jsonGestaoPatrimonial.configuracaoGestaoPatrimonial, HARDCODE.idTipoGestaoPatrimonialVisao)

            if (linhaConfiguracaoGestaoPatrimonial.itemGestaoPatrimonial) {

                setVisao(linhaConfiguracaoGestaoPatrimonial.itemGestaoPatrimonial)
            }
        }

    })

    return (
        visao && (
            visao?.map((itemVisao, indItemVisao) => {

                return (
                    <GridContainer
                        key={indItemVisao}
                        className='justify-center'
                    >
                        <GridItem11>
                            {/*}
                            <RichTextEditorViewer
                                content={itemVisao.richText}
                                backgroundColor={COLOR().bgTransparente}
                            />
                            */}
                            <RichTextEditorViewerPadrao
                                content={itemVisao.richText}
                                backgroundColor={COLOR().bgTransparente}
                            />
                        </GridItem11>
                    </GridContainer>
                )
            })
        )
    )
}

export default GestaoPatrimonialFormVisao